import React, { useState, useEffect } from 'react';
import { toApiDateValue } from '../../utils/dateUtils';

const DateRangeFilter = ({
  selectedPeriod,
  startDate,
  endDate,
  onSelectPreset,
  onApplyCustomRange,
}) => {
  const [localStart, setLocalStart] = useState(startDate || '');
  const [localEnd, setLocalEnd] = useState(endDate || '');

  useEffect(() => {
    setLocalStart(startDate || '');
  }, [startDate]);

  useEffect(() => {
    setLocalEnd(endDate || '');
  }, [endDate]);

  const periods = [
    { key: 'today', label: 'Today' },
    { key: 'week', label: 'This Week' },
    { key: 'month', label: 'This Month' },
  ];

  const computeRange = (periodKey) => {
    const end = new Date();
    const start = new Date();
    if (periodKey === 'today') {
      // already set to now
    } else if (periodKey === 'week') {
      start.setDate(start.getDate() - 7);
    } else {
      start.setMonth(start.getMonth() - 1);
    }
    return { start: toApiDateValue(start), end: toApiDateValue(end) };
  };

  const handleApplyRange = () => {
    if (localStart && localEnd) {
      onApplyCustomRange?.(localStart, localEnd);
      return;
    }
    const range = computeRange(selectedPeriod || 'month');
    setLocalStart(range.start);
    setLocalEnd(range.end);
    onSelectPreset?.(selectedPeriod || 'month', range);
  };

  const handlePresetClick = (periodKey) => {
    const range = computeRange(periodKey);
    setLocalStart(range.start);
    setLocalEnd(range.end);
    onSelectPreset?.(periodKey, range);
  };

  return (
    <div className="flex flex-wrap items-center gap-2 bg-white p-2 rounded-lg shadow-sm">
      {/* Preset Buttons */}
      <div className="flex space-x-1">
        {periods.map(period => (
          <button
            key={period.key}
            onClick={() => handlePresetClick(period.key)}
            className={`px-3 py-1 rounded-md text-sm font-semibold transition-colors ${
              selectedPeriod === period.key
                ? 'bg-blue-500 text-white'
                : 'text-gray-600 hover:bg-gray-100'
            }`}
          >
            {period.label}
          </button>
        ))}
      </div>

      {/* Custom Date Inputs */}
      <div className="flex items-center gap-2 border-l pl-2">
        <input
          type="date"
          value={localStart}
          onChange={(e) => setLocalStart(e.target.value)}
          className="p-1 border rounded-md text-sm"
        />
        <span className="text-gray-500">-</span>
        <input
          type="date"
          value={localEnd}
          onChange={(e) => setLocalEnd(e.target.value)}
          className="p-1 border rounded-md text-sm"
        />
        <button
          onClick={handleApplyRange}
          disabled={false}
          className="px-3 py-1 bg-gray-600 text-white rounded-md text-sm font-semibold hover:bg-gray-700"
        >
          Go
        </button>
      </div>
    </div>
  );
};

export default DateRangeFilter;
